import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { ClockingRecordsSearchSchema } from './-zod-schema';

export const Route = createFileRoute(
  '/_staff/attendances/_layout/clocking-records/',
)({
  validateSearch: zodValidator(ClockingRecordsSearchSchema),
});
